export const getToken = () => sessionStorage.getItem('fsrToken') || null;

export const removeUserSession = () => {
	sessionStorage.removeItem('fsrToken');
	sessionStorage.removeItem('sessionExpiry');
	sessionStorage.removeItem('currentUser');
	sessionStorage.removeItem('refreshToken');
};

export const setActiveUser = user => {
	sessionStorage.setItem('currentUser', user);
};

export const getActiveUser = () =>
	sessionStorage.getItem('currentUser') || null;

export const setUserSession = (token, sessionExpiry, refreshToken) => {
	sessionStorage.setItem('fsrToken', token);
	sessionStorage.setItem('sessionExpiry', sessionExpiry);
	sessionStorage.setItem('refreshToken', refreshToken);
};

export const getSessionToken = () =>
	sessionStorage.getItem('refreshToken') || null;

export const getAccessToken = () =>
	sessionStorage.getItem('fsrToken') || null;


const base64UrlDecode = (input) => {
	try {
		// Replace URL-safe chars
		let base64 = input.replace(/-/g, '+').replace(/_/g, '/');

		// Pad with '=' to multiple of 4
		const pad = base64.length % 4;
		if (pad === 2) base64 += '==';
		else if (pad === 3) base64 += '=';
		else if (pad !== 0) base64 += '';

		// atob for browser
		return atob(base64);
	} catch (e) {
		return null;
	}
};

// Decode JWT payload safely (returns object or null)
const decodeJwtPayload = (token) => {
	try {
		if (!token) return null;
		const parts = token.split('.');
		if (parts.length !== 3) return null; // opaque token
		const payloadStr = base64UrlDecode(parts[1]);
		if (!payloadStr) return null;
		return JSON.parse(payloadStr);
	} catch (e) {
		return null;
	}
};

// Extract exp (ms) if present; else null
export const getTokenExpiryMsFromJwt = (token) => {
	const payload = decodeJwtPayload(token);
	if (!payload || typeof payload.exp !== 'number') return null;
	// exp is in seconds; convert to ms
	return payload.exp * 1000;
};

// Compute remaining time (ms) from either JWT exp or stored expiry_at
export const getRemainingSessionMs = (token) => {
	if (!token) return 0;

	// 1) Prefer JWT exp if available
	const jwtExpiryMs = getTokenExpiryMsFromJwt(token);
	const now = Date.now();

	if (typeof jwtExpiryMs === 'number' && jwtExpiryMs > 0) {
		return Math.max(jwtExpiryMs - now, 0);
	}

	// No info → treat as expired
	return 0;
};
